import React, { useContext } from "react";
import { Link } from "react-router-dom";
import AuthContext from "../../contexts/AuthContext";

import UserMenu from "./components/UserMenu";
import SideMenu from "./components/SideMenu/";

import "./assets/css/header.css";
import "./assets/css/btn-viewscore.css";
import logo from "./assets/images/logo_menu.svg";

const Menu: React.FC = () => {
  const { user, logged } = useContext(AuthContext);
  const showScoreboard = logged && user !== null && user.profile.name !== 'Sender';

  const monthShortNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];
  const date = new Date();
  return (
    <React.Fragment>
      <header className="headerApp">
        <Link to="/">
          <img
            className="header__logo"
            src={logo}
            alt="RedBull On Premise ATLAS"
          />
        </Link>
        {showScoreboard && (
          <div className="header__viewScore viewScore">
            <a href="/scoreboard" target="_blank" className="viewScore__link">
              View Scoreboard
            </a>
          </div>
        )}

        <UserMenu />
        {logged && (
          <span className="date">
            {monthShortNames[date.getMonth()]} {date.getDate()},{" "}
            {date.getFullYear()}
          </span>
        )}
      </header>
      <SideMenu />
    </React.Fragment>
  );
}

export default Menu;
